import React from "react";
import { ButtonA } from "../../styles-components/Buttons";
import {
  Column,
  ErrorMessage,
  Label,
  Row,
} from "../../styles-components/FormItens";
import inputFormat from "../../utils/inputFormat";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";

const EventConfigEdit = ({
  setEventItems,
  eventItems = [],
  config = null,
  setConfig,
}) => {
  const [title, setTitle] = useState(" ");
  const [isEditing, setIsEditing] = useState(false);
  const [descricao, setDescricao] = useState(" ");
  const [validation, setValidation] = useState({ value: false, message: "" });

  const inputTitle = useRef(null);

  const handleNewItem = () => {
    if (title != "" && title != " " && descricao != "" && descricao != " ") {
      if (!isEditing) {
        if (
          eventItems.find((item) => " " + item.title === title) === undefined
        ) {
          setEventItems((prev) => [
            ...prev,
            {
              title: removeValidationSpace(title),
              description: removeValidationSpace(descricao).replace(
                "/\r?\n/g",
                "<br />"
              ),
            },
          ]);
          setTitle(" ");
          setDescricao(" ");
          setValidation({ value: false, message: "" });
        } else {
          inputTitle.current.focus();
          setValidation({
            value: true,
            message: "Já existe um item com esse título",
          });
        }
      } else {
        setEventItems((prev) => {
          prev.map((item, index) => {
            if (item.id === config.id) {
              prev[index] = {
                ...prev[index],
                title: removeValidationSpace(title),
                description: removeValidationSpace(descricao).replace(
                  "/\r?\n/g",
                  "<br />"
                ),
                edited: true,
              };
            }
          });
          return prev;
        });
        setConfig(null);
        setTitle(" ");
        setDescricao(" ");
        setIsEditing(false);
        setValidation({ value: false, message: "" });
      }
    } else {
      setValidation({
        value: true,
        message: "Informe todos os campos do item",
      });
    }
  };

  const handleCancelEdit = () => {
    setConfig(null);
    setTitle(" ");
    setDescricao(" ");
    setIsEditing(false);
    setValidation({ value: false, message: "" });
  };

  const removeValidationSpace = (text) => {
    return text[0] === " " ? text.substring(1) : text;
  };

  useEffect(() => {
    if (config !== null) {
      setTitle(" " + config.title);
      setDescricao(" " + config.description);
      setIsEditing(true);
    }
  }, [config]);

  return (
    <Column style={{ marginTop: "10px" }}>
      <Column>
        <h4>Adicionar informação ao evento</h4>
        <Row>
          <Label>Titulo:</Label>
          <input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            ref={inputTitle}
            style={title != " " && title.length < 1 ? { ...inputFormat } : {}}
          />
        </Row>
        {title != " " && title.length < 1 && (
          <ErrorMessage color="--red">Informe este campo!</ErrorMessage>
        )}
      </Column>
      <Column>
        <Column>
          <Label>Descrição:</Label>
          <textarea
            value={descricao}
            onChange={(e) => setDescricao(e.target.value)}
            style={
              descricao != " " && descricao.length < 1 ? { ...inputFormat } : {}
            }
          ></textarea>
        </Column>
        {descricao != " " && descricao.length < 1 && (
          <ErrorMessage color="--red">Informe este campo!</ErrorMessage>
        )}
      </Column>
      {validation.value && (
        <ErrorMessage align="center" color="--red">
          {validation.message}
        </ErrorMessage>
      )}
      <div>
        <ButtonA
          as="button"
          type="button"
          backgroundColor="--green"
          color="--white"
          style={{ width: "fit-content" }}
          onClick={() => handleNewItem()}
        >
          {isEditing ? "Editar" : "Adicionar"} Item
        </ButtonA>
        {isEditing && (
          <ButtonA
            as="button"
            type="button"
            backgroundColor="--red"
            color="--white"
            style={{ width: "fit-content", float: "right" }}
            onClick={() => handleCancelEdit()}
          >
            Cancelar edição
          </ButtonA>
        )}
      </div>
    </Column>
  );
};

export default EventConfigEdit;
